// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-multi-page',
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        pages: {
            type: Array,
            required: false,
            default: []
        },
        process: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        page: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
        schemaData: {
            type: Object,
            required: false,
            default: {}
        },
        master: {
            type: Object,
            required: false,
            default: {}
        },
    },
    data: () => ({
        _isWorking: false
    }),
    computed: {
        canAddMore() {
            if (this.page.maxOccurs <= 0) {
                return true;
            }
            if (this.page.maxOccurs > this.page.pages.length) {
                return true;
            }
            return false;
        }
    },
    // #endregion
    // #region Core
    methods: {
        onCommand(command, args) {
            //Init
            this._isWorking = true;
            //Run
            this.$emit('command', command, args, () => { this._isWorking = false; });
        },
    }
    // #endregion
});
// #endregion
